import { WhiteLabelTextTheme } from '@/types'
import {
  AgentConfigurationStyle,
  WhiteLabelTextStyle,
  WhitelabelFontWeights,
} from '@big-red-group/storefront-common-checkout'
import { DefaultTheme } from 'styled-components'

export const getSiteTheme = (style: AgentConfigurationStyle | undefined): DefaultTheme => {
  const textStyles: WhiteLabelTextTheme = {
    font: style?.text?.font || defaultTextStyles.font!,
    colours: style?.text?.colours || defaultTextStyles.colours!,
  }

  // `style.platform` is how we can get the platform (exoz|adr|rb) from the common ui component
  // check here https://github.com/Big-Red-Group/storefront-common-ui/blob/main/src/Afterpay.styles.tsx
  if (style && 'text' in style) {
    style.text = textStyles
    style.platform = 'exoz'
  } else {
    style = { ...style, text: textStyles, platform: 'exoz' }
  }

  return style as DefaultTheme
}

export const defaultTextStyles: WhiteLabelTextStyle = {
  font: {
    name: 'Figtree',
    weights: { light: 300, regular: 400, medium: 500, bold: 700 },
  },
  colours: {
    homeHeading: '#FFFFFF',
    heading: '#1A1D1E',
    body: '#1A1D1E',
  },
}

export const getFontWeightString = (weights: WhitelabelFontWeights) => {
  return `${weights.light};${weights.regular};${weights.medium};${weights.bold}`
}
